import ServiceTypesModel from '../../models/service/ServiceTypesModel.js';

const ServiceTypesCollection = Backbone.Collection.extend({

  model: ServiceTypesModel,

  initialize() {
  },

  sync(method, collection, options) {
    const params = _.omit($.extend(true, {}, options), ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache']);
    const defer = $.Deferred();

    options.reset = (options.reset === undefined ? true : options.reset);
    options.refreshCache = options.refreshCache || false;

    Sendible.Connect.serviceTypes('', params, _.bind((data) => {
      options.success(data);
      defer.resolve(data);
    }, this), (data) => {
      if (options.error) options.error(data);
      defer.reject(data);
    });

    const promise = defer.promise();
    return promise;
  },

});

export default ServiceTypesCollection;
